module.exports = __webpack_public_path__ + "static/media/do-pobrania-cwiczenia.3ea9ea16.png";